import React, { FC, useRef, useEffect, HTMLAttributes } from "react";

import { DataType, SelectedType } from "./Filter";
import {
  StyledStartMenuTitle,
  StyledStartMenuListItem,
  StyledStartMenuList,
  StyledStartMenuNoResults,
} from "./Styles";
import { useResizeObserver } from "../../utils";
import { Badge } from "../Badge";
import { ArrowRightIcon } from "../Icons";

export interface StartMenuProps {
  data: Array<DataType>;
  selected: SelectedType;
  onItemClick: (id: number | string) => void;
  onHeightChange: (height: number) => void;
  shouldRenderSubmenus: boolean;
  emptyFilterText?: string;
}

export const StartMenu: FC<StartMenuProps & HTMLAttributes<HTMLDivElement>> = ({
  data,
  selected,
  onItemClick,
  style,
  onHeightChange,
  shouldRenderSubmenus,
  emptyFilterText,
  children,
}) => {
  const ref = useRef(null);
  const dimensions = useResizeObserver(ref);
  const height = dimensions?.height;

  useEffect(() => {
    if (height && height > 0) {
      onHeightChange(height);
    }
  }, [height, onHeightChange]);

  return (
    <div style={style} ref={ref}>
      <StyledStartMenuList>
        {shouldRenderSubmenus ? (
          data.map(({ id, title, submenu }, index: number) => {
            let count = 0;
            // Popricati o ovome kada je selected[id] vrednost 0.
            if (typeof selected[id] === "string") {
              count += 1;
            } else {
              count = selected[id]?.length;
            }

            if (submenu?.length > 1) {
              return (
                <StyledStartMenuListItem
                  key={`filter-list-item-${index}`}
                  onClick={() => onItemClick(id)}
                >
                  <StyledStartMenuTitle>{title}</StyledStartMenuTitle>
                  {count > 0 ? (
                    <Badge dimension={16} value={count} isStandalone={true} />
                  ) : null}
                  <ArrowRightIcon />
                </StyledStartMenuListItem>
              );
            }
          })
        ) : emptyFilterText ? (
          <StyledStartMenuNoResults>{emptyFilterText}</StyledStartMenuNoResults>
        ) : null}
        {children}
      </StyledStartMenuList>
    </div>
  );
};
